/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBenefitAmountQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetBenefitAmountQuery = { __typename?: 'Query', surveyBenefitAmount: { __typename?: 'BenefitAmount', id: string, benefitAmount: number, expectIncomeIncrease: boolean | null, maximumBenefit: number, minimumBenefit: number } };


export const GetBenefitAmountDocument = gql`
    query GetBenefitAmount {
  surveyBenefitAmount {
    id
    benefitAmount
    expectIncomeIncrease
    maximumBenefit
    minimumBenefit
  }
}
    `;
export function useGetBenefitAmountQuery(baseOptions?: Apollo.QueryHookOptions<GetBenefitAmountQuery, GetBenefitAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBenefitAmountQuery, GetBenefitAmountQueryVariables>(GetBenefitAmountDocument, options);
      }
export function useGetBenefitAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBenefitAmountQuery, GetBenefitAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBenefitAmountQuery, GetBenefitAmountQueryVariables>(GetBenefitAmountDocument, options);
        }
export function useGetBenefitAmountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBenefitAmountQuery, GetBenefitAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBenefitAmountQuery, GetBenefitAmountQueryVariables>(GetBenefitAmountDocument, options);
        }
export type GetBenefitAmountQueryHookResult = ReturnType<typeof useGetBenefitAmountQuery>;
export type GetBenefitAmountLazyQueryHookResult = ReturnType<typeof useGetBenefitAmountLazyQuery>;
export type GetBenefitAmountSuspenseQueryHookResult = ReturnType<typeof useGetBenefitAmountSuspenseQuery>;
export type GetBenefitAmountQueryResult = Apollo.QueryResult<GetBenefitAmountQuery, GetBenefitAmountQueryVariables>;